import { Flex, Box, Text } from "@chakra-ui/react";
import { BookDemoButton } from "components/event-tracking";
import { type CdpVendor } from "lib/sanity";
import React from "react";
import Balancer from "react-wrap-balancer";
import { VendorVsGraphic } from "./vendor-vs-graphic";

type CompareCdpsArticleHeroProps = {
  title: string;
  description: string;
  firstCdpVendor: CdpVendor;
  secondCdpVendor: CdpVendor;
};

export function CompareCdpsArticleHero({
  title,
  description,
  firstCdpVendor,
  secondCdpVendor,
}: CompareCdpsArticleHeroProps) {
  return (
    <Flex
      align="center"
      justify={{ base: "center", lg: "space-between" }}
      direction={{ base: "column", lg: "row" }}
      gap={{ base: 12, md: 16, xl: 28 }}
      zIndex={1}
    >
      <Box flex={1} textAlign={{ base: "center", lg: "left" }} maxW="xl" mx="auto" zIndex={1}>
        <Text as="h1" textStyle="article.h2">
          <Balancer>{title}</Balancer>
        </Text>

        <Text as="h2" textStyle="article.p" color="brand.textSecondary.light" mt={8} mb={12}>
          {description}
        </Text>

        <Flex justify={{ base: "center", lg: "start" }}>
          <BookDemoButton />
        </Flex>
      </Box>

      <VendorVsGraphic firstCdpVendor={firstCdpVendor} secondCdpVendor={secondCdpVendor} />
    </Flex>
  );
}
